import React from 'react';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';
import ContextualLink from '@magoosh/gre/app/contextual_link';
import style from './style.module.scss';
import Icon from '@magoosh/gre/assets/icons';
import TopicOverviewIllustration from '../../assets/topic_overview.svg';
import { paths } from 'config/path_helpers';
import { UserProvider } from '@magoosh/context/user_context';
import MathContent from './tabs/math_content';
import VerbalContent from './tabs/verbal_content';
import WritingContent from './tabs/writing_content';
import { HeaderWithIllustration } from '../../lib/header_with_illustration';
import { PageCard } from '../../lib/page_card';
import { Wrapper } from '../../lib/wrapper';
import { TabButton } from '@magoosh/lib/button';

export const TopicOverview: React.FC = () => {
  const sectionName = useParams().sectionName || 'math';

  return (
    <Wrapper>
      <Helmet>
        <title>Topic Overview - Magoosh GRE</title>
      </Helmet>

      <div className="u-margin-V-m">
        <ContextualLink href={paths.dashboard()}>
          <strong>Home</strong>
        </ContextualLink>{' '}
        {'>'} <span>Topic Overview</span>
      </div>

      <PageCard>
        <HeaderWithIllustration
          illustration={TopicOverviewIllustration}
          illustrationAltText={'Topic Overview Illustration'}
          icon={<Icon iconType="Topic" fill={style.iconSecondary} />}>
          <h2 className="u-margin-A-n">
            <strong>Topic Overview</strong>
          </h2>
          <p>
            View your progress through all topics available in Magoosh and add specific topics to your study
            plan as desired.
          </p>
        </HeaderWithIllustration>

        <UserProvider>
          <hr className="u-margin-B-xs" />

          <div className="text-center">
            <ContextualLink href={paths.topicOverview('math')}>
              <TabButton disabled={sectionName === 'math'}>Math</TabButton>
            </ContextualLink>
            <ContextualLink href={paths.topicOverview('verbal')}>
              <TabButton disabled={sectionName === 'verbal'}>Verbal</TabButton>
            </ContextualLink>
            <ContextualLink href={paths.topicOverview('writing')}>
              <TabButton disabled={sectionName === 'writing'}>Writing</TabButton>
            </ContextualLink>
          </div>

          <hr className="u-margin-T-xs" />

          {sectionName === 'math' && <MathContent />}
          {sectionName === 'verbal' && <VerbalContent />}
          {sectionName === 'writing' && <WritingContent />}
        </UserProvider>
      </PageCard>
    </Wrapper>
  );
};

export default TopicOverview;
